import { memo } from "react";

type PreviewData = {
  text: string;
  media: string | null;
};

type BroadcastPreviewCellProps = {
  preview: PreviewData;
};

const BroadcastPreviewCell = ({ preview }: BroadcastPreviewCellProps) => {
  const isVideo = preview.media?.includes("youtube");

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {preview.media && (
        isVideo ? (
          <iframe
            width="150px"
            height="80px"
            src={preview.media}
            frameBorder="0"
            allowFullScreen
            title={`Video preview for ${preview.text}`}
          />
        ) : (
          <div
            style={{
              maxWidth: "150px",
              maxHeight: "80px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={preview.media}
              alt="Preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>
        )
      )}
      <p style={{ height: "80px", display: "flex", alignItems: "center" }}>
        {preview.text}
      </p>
    </div>
  );
};

export default memo(BroadcastPreviewCell);
